var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('decision-log-inline-row'),_vm._v(" "),_c('decision-log-panel',{attrs:{"open":_vm.isPanelOpen},on:{"close":function($event){return _vm.$emit('request-panel', null)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }